<template>
    <div>
      <div class="row">
        <div class="panel panel-info">
            <div class="panel-heading">
                <h3 class="panel-title">Filter Orders</h3>
            </div>
          <div class="panel-body">
            <div class="form form-inline">
            <label>Status</label>
              <button class="btn btn-primary" v-bind:class="{ active: showNew }" @click="showNew = !showNew">New<span v-if="showNew">&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></button>
              <button class="btn btn-success" v-bind:class="{ active: showShipped }" @click="showShipped = !showShipped">Shipped<span v-if="showShipped">&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></button>
              <button class="btn btn-warning" v-bind:class="{ active: showInProgress }" @click="showInProgress = !showInProgress">In Progress<span v-if="showInProgress">&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></button>
              <button class="btn btn-danger" v-bind:class="{ active: showCancelled }" @click="showCancelled = !showCancelled">Cancelled<span v-if="showCancelled">&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></button>
            </div>
          </div>
        </div>
      </div>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Orders</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th class="text-center">Order Date</th>
                        <th>Account</th>
                        <th>Order Items</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(order, index) in orders" v-if="showOrder(order)">
                        <td class="text-center">{{ formatOrderDate(order.ordered_at) }}</td>
                        <td>{{ order.account ? order.account.account_name : '' }}</td>
                        <td>
                            <p v-for="orderItem in order.order_items">
                                {{ orderItem.product.name }} x {{ orderItem.quantity }} = {{ orderItem.total_price | currency }}
                                <template v-for="variant in orderItem.variants">
                                    <br> <strong>{{ variant.label }}:</strong> {{ variant.value }}
                                </template>
                                <template v-if="orderItem.personalisation">
                                    <br /><strong>Personalisation:</strong> {{ orderItem.personalisation }}
                                </template>
                            </p>
                        </td>
                        <td>{{ order.status | status }}</td>
                        <td>
                            <button :disabled="order.status == 'in_progress' || order.status=='cancelled'" @click="changeStatus(order.id, 'in_progress')" class="btn btn-warning">In progress</button>
                            <button :disabled="order.status == 'shipped' || order.status=='cancelled'" @click="changeStatus(order.id, 'shipped')" class="btn btn-success">Shipped</button>
                            <button :disabled="order.status == 'cancelled'" @click="changeStatus(order.id, 'cancelled')" class="btn btn-danger">Cancelled</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    </div>


</template>
<script>
    export default {
        data: function () {
            return {
                orders: [],
              showNew: true,
              showInProgress: true,
              showShipped: false,
              showCancelled: false

            }
        },

        mounted() {
            this.getOrders();
        },

        methods: {
            getOrders() {
                axios.get('/api/v1/orders').then((response) => {
                    this.orders = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club orders.', type: 'error'});
                });
            },

            changeStatus(id, status)
            {
                axios.put(`/api/v1/orders/${id}`, {
                        status: status
                    })
                    .then(response => {
                        this.getOrders();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem updating the order.', type: 'error'});
                    });
            },
            showOrder(order) {
                if (order.status == "new" && this.showNew) {
                    return true;
                }
                if (order.status == "in_progress" && this.showInProgress) {
                    return true;
                }
                if (order.status == "shipped" && this.showShipped) {
                    return true;
                }
                if (order.status == "cancelled" && this.showCancelled) {
                    return true;
                }
            },
            formatOrderDate(theDateString) {
                let theOrderDate = new Date(theDateString);
                return theOrderDate.toLocaleDateString('en-GB');
            }
        },

        filters: {
            status(value) {
                return _.startCase(value);
            }
        }
    }
</script>
